import {withPayloadType} from '@lib/utils';
import {createAction} from '@reduxjs/toolkit';

export const setIsNewUserSession = createAction('data/profiles/setIsNewUserSession', withPayloadType<boolean>());
